
<template>
  <div style="background-color: rgba(236, 243, 255, 1);">
    <HeadVue></HeadVue>
    <section class="banner" style="margin-top: 60px">
      <div style="margin-right: 425px">
        <h1>注入AI能力，重塑企业生产力新格局</h1>
        <p>深耕企业级应用天地，无缝衔接非结构化数据大预言模型，匠心打造全栈式数据基建根据</p>
      </div>

    </section>

    <section class="section">
      <div style="display: flex;justify-content: center;margin-top: 55px;margin-bottom: 30px">
        <h2 class="section-title">工业企业AI生产力构建</h2>
      </div>
      <div class="card-container">
        <div class="card">
          <img src="./assets/img/scheme-cart1.png" alt="机器视觉" class="card-img">
          <div class="card-content">
            <h3>AI工具</h3>
            <p>基于数据驱动学习模式，自动采集并深度处理多源数据，经反复训练，精准生成具备特定功能的智能软件，有力提升任务执行的精准度与效率</p>
          </div>
        </div>
        <div class="card">
          <img src="./assets/img/scheme-cart2.png" alt="预测性维护" class="card-img">
          <div class="card-content">
            <h3>AI智能体</h3>
            <p style="text-align: justify">具备自主学习能力，可灵活调用 AI 工具，广泛吸纳知识，精准掌握特定技能，以智能代理身份独立应对复杂任务，保障工作高质量完成</p>
          </div>
        </div>
        <div class="card">
          <img src="./assets/img/scheme-cart3.png" alt="质量控制" class="card-img">
          <div class="card-content">
            <h3>自动化工作</h3>
            <p style="text-align: justify">通过构建协同体系，组织多个 AI 智能体有序协作。针对重复性任务与工作流，依据预设流程自动分配任务，高效执行，确保工作连贯性与稳定性</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div style="display: flex;justify-content: center;margin-top: 35px;margin-bottom: 30px">
        <h2 class="section-title">开创工业场景效率的新时代</h2>
      </div>
      <div class="feature-container">
        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/scheme-feature1.png" alt="智能工厂">
          </div>
          <div class="feature-text">
            <h3>物料管理</h3>
            <p>凭借卓越的数据处理技术，自动聚焦物料，深度剖析数据，快速精准生成物料信息与参数配置，大幅提升建档效率，确保数据精准连贯，为生产与供应链筑牢根基</p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/scheme-feature2.png" alt="生产优化">
          </div>
          <div class="feature-text">
            <h3>生产规划</h3>
            <p>迈入生产计划关键阶段，依托海量数据深度挖掘能力，化身专业规划大师，精心制定生产与资源优化方案，科学分配任务、精准设定时间节点，保障流程顺畅、资源最优，提升生产效能，助力企业快速响应市场</p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/scheme-feature3.png" alt="协作决策">
          </div>
          <div class="feature-text">
            <h3>客户关系</h3>
            <p>运用全方位客户数据分析技术，构思客户关系优化策略与实时档案，助力企业精准把握需求，提供个性化服务，提升满意度，拉紧客户纽带，增强竞争力</p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/scheme-feature4.png" alt="仓储物流">
          </div>
          <div class="feature-text">
            <h3>采购管理</h3>
            <p>聚焦采购关键节点，以专业评估技术审视供应商绩效与风险，输出优化建议，助企业高效管控供应商，规避风险，深化合作，保障物料供应稳定、成本效益最佳</p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/scheme-feature5.png" alt="安全监控">
          </div>
          <div class="feature-text">
            <h3>质量管控</h3>
            <p>借助自动化检验技术，聚焦工序数据，瞬间生成精准结果与改进建议，革新传统检验，以标准化流程确保产品质量，推动企业持续改进</p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/scheme-feature6.png" alt="能源管理">
          </div>
          <div class="feature-text">
            <h3>库存管理</h3>
            <p>利用智能算法助力盘点与分类，快速输出盘点成果与优化妙招，帮企业摆脱库存困境，提升管理效率，优化库存结构，盘活资金流</p>
          </div>
        </div>
        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/scheme-feature7.png" alt="安全监控">
          </div>
          <div class="feature-text">
            <h3>财务管理</h3>
            <p>通过深度成本数据分析，打造实用报告与优化策略，助力企业精细管控成本、拓宽盈利空间，保障可持续发展</p>
          </div>
        </div>
      </div>
    </section>

    <section class="solution-section">
      <div style="display: flex;justify-content: center;margin-top: 15px;margin-bottom: 30px">
        <h2 class="section-title">开创工业场景效率的新时代</h2>
      </div>
      <div class="solution-container" style="padding-bottom: 80px">
        <div class="solution-item">
          <div>
            <h3>团队优势</h3>
          </div>
          <div style="display: flex;flex-direction: column">
            <p>•公司团队在企业数字化转型与人工智能技术应用领域深耕多年，专业造诣深厚</p>
            <p>•创始成员均来自世界 500 强及头部互联网大厂，凭借深厚行业积淀、前沿技术视野与精湛专业技能，已为近百家中国企业定制化交付系统与软件解决方案</p>
            <p>•具备精准洞察行业痛点的能力，能高效赋能企业数字化变革，实战履历丰富，专业功底扎实</p>
          </div>
        </div>
        <div class="solution-item">
          <div>
            <h3>技术领先</h3>
          </div>
          <div style="display: flex;flex-direction: column">
            <p>•自主投入研发，攻克多项技术难关，研发出一整套 AI 原生应用开发算法与模型体系</p>
            <p>•体系涵盖工业级生成式知识管理及先进的计算智能体功能模块，具备快速复用、轻定制化能力</p>
            <p>•在低算力资源配置下，可实现卓越的高性能组合编排效果，以突破性技术引领行业前沿，为企业智能化升级提供</p>
          </div>
        </div>
        <div class="solution-item">
          <div>
            <h3>高性能部署</h3>
          </div>
          <div style="display: flex;flex-direction: column">
            <p>•自主构建的企业级应用开发框架设计精妙，采用模块化接口架构，实现内外部 API 接口无缝对接与高效交互</p>
            <p>•面对客户复杂多变业务需求，能依托框架迅速拓展场景应用，确保系统灵活性与扩展性</p>
            <p>•在高并发查询场景下，展现卓越稳定性与高效响应能力，保障业务流程顺畅运行，提升用户</p>
          </div>
        </div>
        <div class="solution-item">
          <div>
            <h3>自主可控</h3>
          </div>
          <div style="display: flex;flex-direction: column">
            <p>•企业级全栈解决方案成熟稳健，底层架构设计兼容性高，适配国内外多种主流源大模型，提供多元化技术选型</p>
            <p>•支持独立环境私有化部署模式，从网络架构、数据存储到应用运行，全方位构筑安全防护体系</p>
            <p>•确保企业数据资产的安全性与合规性，让企业在数字化进程中掌握自主控制权，从容应对潜在风险</p>
          </div>
        </div>
      </div>
    </section>
    <FooterVue style="margin-top: 0"></FooterVue>
  </div>
</template>

<script>
import HeadVue from "@/views/common/HeadVue.vue";
import FooterVue from "@/views/common/FooterVue.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  components: {FooterVue, HeadVue},
  metaInfo: {
    title: '滁州人工智能-明晟智能科技有限公司',
    meta: [
      { name: 'description', content: '明晟智能科技有限公司是专注于垂直领域大语言模型技术创新的领军企业，致力于将智能科技深度融入高等教育、政务管理、医疗健康及新能源等多元领域' },
      { property: 'og:type', content: 'webpage' },
      { property: 'og:title', content: '滁州人工智能-明晟智能科技有限公司' },
      { property: 'og:description', content: '明晟智能科技有限公司是专注于垂直领域大语言模型技术创新的领军企业，致力于将智能科技深度融入高等教育、政务管理、医疗健康及新能源等多元领域' },
      { property: 'og:url', content: 'https://minsun-ai.com/' },
      { name: 'Keywords',content: "明晟智能科技有限公司,明晟,明晟智能,滁州人工智能,人工智能,AI,明晟大模型,明晟工业大模型"}
    ]
  },
}
</script>

<style scoped lang="css">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", sans-serif;
}

body {
  background-color: #f5f9ff;
  color: #333;
  line-height: 1.6;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 50px;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.logo {
  height: 40px;
}

.nav {
  display: flex;
  gap: 20px;
}

.nav-item {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}

.banner {
  height: 500px;
  //width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100% ;
  //text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image:  url("./assets/img/banner.png");
}

.banner h1 {
  background-image: linear-gradient(45deg, rgba(7, 103, 252, 1) 0, rgba(22, 237, 140, 1) 100%);
  //width: 205px;
  height: 56px;
  overflow-wrap: break-word;
  font-size: 50px;
  font-family: Alimama ShuHeiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 56px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 20px;

}

.banner p {
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  text-align: left;
}

.banner-img {
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.floating-element {
  position: absolute;
  opacity: 0.6;
  z-index: 1;
}

.floating-1 {
  top: 10%;
  left: 10%;
  animation: float 8s ease-in-out infinite;
}

.floating-2 {
  bottom: 15%;
  right: 10%;
  animation: float 10s ease-in-out infinite;
}

.floating-3 {
  top: 60%;
  left: 15%;
  animation: float 12s ease-in-out infinite;
}

@keyframes float {
  0% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(5deg); }
  100% { transform: translateY(0) rotate(0deg); }
}

.section {
  padding: 20px 0;
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 32px;
  color: #181F5C;
  margin-bottom: 20px;
  position: relative;
  text-align: center;
  font-family: "Alimama ShuHeiTi-Bold";
}
.section-title:before{
  left: -135px !important;
}
.section-title:after{
  right: -135px !important;
}
.section-title:before {
  content: "";
  background-image: url('assets/img/title-icon-left.png');
  position: absolute;
  width: 112px;
  height: 59px;
  //background-color: #0052d9;
  bottom: -10px;

  //transform: translateX(-50%);
}
.section-title:after {
  content: "";
  background-image: url('assets/img/title-icon-right.png');
  position: absolute;
  width: 112px;
  height: 59px;
  //background-color: #0052d9;
  bottom: -10px;
  right: 185px;
  //transform: translateX(-50%);
}

.card-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 30px auto;
  flex-wrap: wrap;
}

.card {
  //background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  width: 386px;
  text-align: left;
  transition: transform 0.3s ease;
}

.card-img {
  //width: 100%;
  ////height: 200px;
  //object-fit: cover;
}

.card-content {
  //width: 386px;
  height: 212px;
  background: linear-gradient( 180deg, #ECF1F9 0%, #FEFEFF 100%);
  border-radius: 0px 0px 0px 0px;
  //border: 1px solid #FFFFFF;
  padding: 20px;
}

.card h3 {
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  font-family: "Alimama ShuHeiTi-Bold";
  //margin-top: 10px;
}

.card p {
  width: 346px;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
}

.feature-section {
  background-color: #fff;
  padding: 40px 0;
}

.feature-container {
  max-width: 1200px;
  margin: 0 auto;
}

.feature-item {
  display: flex;
  margin-bottom: 40px;
  align-items: center;
}

.feature-item:nth-child(even) {
  flex-direction: row-reverse;
}

.feature-img {
  flex: 1;
  padding: 20px;
}

.feature-img img {
  width: 100%;
  border-radius: 10px;
  //box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.feature-text {
  flex: 1;
  padding: 20px;
  text-align: left;
}

.feature-text h3 {
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  font-family: "Alimama ShuHeiTi-Bold";
}

.feature-text p {
  width: 560px;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
}

.solution-section {
  //padding: 40px 0;
  //background-color: #f5f9ff;
}

.solution-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.solution-item {
  //width: 48%;
  //background-color: #fff;
  //border-radius: 10px;
  //padding: 20px;
  //margin-bottom: 20px;
  //box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  //text-align: left;
  margin-bottom: 20px;
}
.solution-item div:nth-child(1){
  width: 590px;
  height: 50px;
  background: linear-gradient( 45deg, #0767FC 0%, rgba(7,103,252,0) 100%);
  border-radius: 0px 0px 0px 0px;
  display: flex;
  align-items: center;
}
.solution-item div:nth-child(2){
  width: 590px;
  height: 305px;
  background: linear-gradient( 180deg, #ECF1F9 0%, #FEFEFF 100%);
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #FFFFFF;
  display: flex;
  align-items: center;
  padding: 20px;
  p{
    text-align: justify;
  }
}
.solution-item h3 {
  font-weight: 700;
  font-size: 24px;
  color: #FFFFFF;
  font-family: "Alimama ShuHeiTi-Bold";
  margin-left: 20px;
}


.solution-item p {
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  width: 590px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 10px;
}

.footer {
  background-color: #0066cc;
  color: white;
  padding: 40px 0;
}

.footer-container {
  display: flex;
  justify-content: space-around;
  max-width: 1200px;
  margin: 0 auto;
  flex-wrap: wrap;
}

.footer-column {
  flex: 1;
  min-width: 200px;
  margin: 10px;
}

.footer-column h3 {
  margin-bottom: 20px;
  font-size: 18px;
}

.footer-column p, .footer-column a {
  color: #e6f0ff;
  text-decoration: none;
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
}

.qrcode {
  width: 100px;
  height: 100px;
  margin-top: 10px;
}
</style>
